import Image from "next/image"
import Button from "../General/Button"
import Link from "next/link"
import { useDispatch, useSelector } from "react-redux"
import { handleAuthModal } from "../../store/AuthSlice"
import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/slide.css';
import styles from "../../styles/Layout/Navbar.module.css"
import ProfileDrawer from "./ProfileDrawer"
import { useState } from "react"
import helpers from "../../utils/helpers"
import styled from "styled-components"
import Search from "../ProductSearch"
import { useRouter } from "next/router"
import ProfileMenu from "./ProfileMenu"
import LinearLoader from "../General/LinearLoader"

const AnimatedBorderDiv = styled.div`
	&::after {
		content : '';
		display: block;
        width: 30%;
        margin: 10px auto 0 auto;
        background-color: #EC6303;
        height: 3px;
	}

	&:hover::after {
		width : 100%;
		transition : 0.6s;
	}
`

function Navbar(props: any) {
	const getInTouchUrls = [
		'/',
		'/products/[slug]',
	]

	const dispatch = useDispatch();
	const { user } = useSelector((state: any) => state.auth);
	const [showDrawer, setShowDrawer] = useState(false)
	const router = useRouter();
	
	// Handle Auth Modal
	const openDialog = (ID = null) => {
		dispatch(handleAuthModal(true));

		// if(ID) 
		//     dispatch(setRedirectTo(`deals/${ID}`));
	}

	return (
		<>
			<LinearLoader />
			<div className="sticky top-0 z-10 bg-white logo flex justify-between items-center --align" style={{ boxShadow: '0px 3px 6px #00000019', paddingTop: 10, paddingBottom: 10 }}>
				<Link href={'/'}>
					<img className={`cursor-pointer ${styles.logo}`} src={'/logo.png'} alt="logo" />
				</Link>

				<div className="hidden lg:block w-[30%] relative">
					<Search
						shadow={false}
						styles={`border border-[#707070]/40 rounded-[4px]`}
						searchIconHeight="w-4 h-4 lg:w-5 lg:h-5"
						prefixStyles='m-[4px] ml-[2px]'
					/>
				</div>

				<div className="flex items-center">
					<div className="flex gap-x-8 text-theme-black font-[400]">
						<Link href={'/spot-buying'} className={`hidden lg:inline-block ${router.asPath == '/spot-buying' && 'text-theme-orange font-[500] border-b-2 border-theme-orange'}`}>Spot Buying</Link>
						{/* <Link href={'/under-development'} className={`hidden lg:inline-block ${router.asPath == '/under-development' && 'text-theme-orange font-[500] border-b-2 border-theme-orange pb-2'}`}>Bulk Deals</Link> */}
						<p className="hidden lg:inline-block cursor-pointer" onClick={() => router.pathname === '/products/[slug]' ? helpers.scrollTo('get-in-touch', 140) : helpers.scrollTo('enquiry-section', 140)}>Bulk Deals</p>
						{
							!user.isLoggedIn &&
							<AnimatedBorderDiv className="hidden text-[16px] text-theme-black mr-[50px] cursor-pointer md:block">
								<a href={process.env.NEXT_PUBLIC_SELLER_HOME_PAGE_URL} target="_blank">
									Sell on API Drug
								</a>
							</AnimatedBorderDiv>
						}
					</div>
					{
						user.isLoggedIn ?

							<div>
								<div className={`flex items-center ${styles.burger}`}>
									<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 mr-5">
										<path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
									</svg>

									<svg onClick={() => setShowDrawer(true)} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8 cursor-pointer">
										<path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
									</svg>
								</div>

								<div className={`button flex items-center ml-8 ${styles.getInTouch}`}>
									<ProfileMenu />

									{
										getInTouchUrls.includes(router.pathname) &&	
										<Button
											onClick={() => router.pathname === '/products/[slug]' ? helpers.scrollTo('get-in-touch', 140) : helpers.scrollTo('enquiry-section', 140)}
											styles="bg-theme-orange text-white ml-7" width={140} height={43}
											destinationEvent={router.pathname === '/products/[slug]' ? "Scrolled To 'Get In Touch Form'" : "Scrolled To 'Footer'"}
										>
											Get In Touch
										</Button>
									}
								</div>
							</div> :

							<div className="button flex items-center">
								<Button
									onClick={openDialog}
									styles="bg-theme-orange text-sm lg:text-base text-white font-light w-[130px] h-[40px] lg:w-[160px] lg:h-[43px]"
									destinationEvent="Login/Register popup Opened"
								>
									Login / Register
								</Button>
							</div>
					}
				</div>
			</div>
			<ProfileDrawer show = {showDrawer} onClose = {() => setShowDrawer(false)} />
		</>
	)
}

export default Navbar